import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import pick from 'lodash/pick';
import Joi from 'joi-full';

import withNotifications from '../../../common/withNotifications';
import { fetchUser, updateUser, deleteUser, gdprDeleteUser } from '../../users/actions';
import { trimFunction } from '../../../common/trimData';
import { getUser } from '../../users/selectors';
import { syncValidateData } from '../../../common/validator';
import CustomerForm from '../components/Customer';
import confirmModal from '../../../common/confirmModal';

const schema = Joi.object().keys({
  username: Joi.string()
    .min(3)
    .required(),
});

const updateFields = ['username'];

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      initialValues: getUser(state, ownProps.params.id),
    }),
    { fetchUser, updateUser, deleteUser, gdprDeleteUser }
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchUser(this.props.params.id, ['customer']);
    },
  }),
  withNotifications,
  withHandlers({
    onSubmit: props =>
      trimFunction(data =>
        props.updateUser(props.params.id, pick(data, updateFields)).then(() =>
          props.addNotification({
            title: 'Success',
            level: 'success',
            message: 'User successfully updated.',
          })
        )
      ),
    deleteUser: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete user',
        message: 'Are you sure you want to delete this user?\nCustomer will stay intact.',
      });

      if (!confirmed) return false;
      return props.deleteUser(props.params.id).then(() => props.router.push('/admin/customers'));
    },
    gdprDeleteUser: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'GDPR Delete user',
        message: 'Are you sure you want to delete this user?\nCustomer data will be erased in complianace with GDPR.',
      });

      if (!confirmed) return false;
      return props.gdprDeleteUser(props.params.id).then(() => props.router.push('/admin/customers'));
    },
  }),
  reduxForm({
    form: 'adminCustomers',
    validate: values => syncValidateData(values, schema),
  })
)(CustomerForm);
